import React from "react"
import Share from "./index";
import TippyIcon from "./../Atom/TippyIcon";
import { dashboardColors, theme } from "./../../themes/Theme";

const ShareQuickButton = ({ onClick, status, className, disabled, style, content, size, url = "", code = "", type = "url" }) => (
    <Share url={url} type={type} code={code}>
        <TippyIcon content={content ? content : `Share`} placement="bottom">
            <i
                style={{ fontSize: `${size ? size : "16px"}`, color: dashboardColors[theme].primary, ...(style && { ...style }) }}
                className={`${status === 'completed' ? 'fa fa-share-alt' : 'fas fa-share-alt'} pen-color ${className}`}
                disabled={disabled ? disabled : false}
                onClick={onClick}>
            </i>
        </TippyIcon>
    </Share>
)

export default ShareQuickButton;